import React from "react"
import { BrowserRouter } from "react-router-dom"
import { RecoilRoot } from "recoil"
import { Body } from "./Body"
import { LoginProvider } from "./providers/LoginProvider"

import "./App.css"
import MuiThemeProvider from "./providers/MuiThemeProvider"

function App() {
  return (
    // LoginProvider must be inside the BrowserRouter.
    // This is because we use the useNavigate hook in the LoginProvider.
    <BrowserRouter>
      <RecoilRoot>
        <LoginProvider>
          <MuiThemeProvider>
            <Body />
          </MuiThemeProvider>
        </LoginProvider>
      </RecoilRoot>
    </BrowserRouter>
  )
}

export default App
